import {formatDateMoment, setCurrency} from "../../utils/utils";
import Badge from "../../components/commons/badge";
import Button from "../../components/commons/button";
import icEyeOpen from "../../assets/images/ic-eye-open.svg";
import icTrash01Red from "../../assets/images/ic-trash-01-red.svg";
import icFileEdit02 from "../../assets/images/ic-file-edit-02.svg";
import {ACTION_TYPE} from "../../constants/constant";

export const TABLE_PAYROLL_LIST = {
    name: 'Data Payroll',
    column: [
        {
            name: "Bulan Payroll",
            key: "month_year",
            className: "font-bold capitalize"
        },
        {
            name: "Jumlah Employee",
            key: "total_employee",
            className: "font-bold capitalize"
        },
        {
            name: "Total Payroll",
            key: "total_payroll",
            className: "font-bold capitalize",
            render: ({value}) => setCurrency(value)
        },
        {
            name: "Waktu Pengiriman Payroll",
            key: "payment_time",
            render: ({value}) => <div>{value ? formatDateMoment(value, 'D MMMM YYYY HH:mm') : '-'}</div>
        },
        {
            name: "Status Payroll",
            key: "status",
            render: ({value}) => value ? <Badge title={value} type={value?.toLowerCase()}/> : ''
        },
        {
            name: "Action",
            key: "action",
            classNameHeader: "!text-center",
            render: ({item, onClickItem}) => (
                <div className="flex space-x-4 justify-center">
                    <Button className="w-[80px]" type="outline" icon={icEyeOpen} title="Detail"
                            onClick={() => onClickItem({item, actionType: ACTION_TYPE.DETAIL})}/>
                    <Button className="w-[80px]" type="outline" icon={icFileEdit02} title="Payroll Notes" disabled={item?.status === 'drafted'}
                            onClick={() => onClickItem({item, actionType: ACTION_TYPE.PAYROLL_NOTES})}/>
                    <Button type="danger" icon={icTrash01Red} disabled={item?.status !== 'drafted'}
                            onClick={() => onClickItem({item, actionType: ACTION_TYPE.DELETE})}/>
                </div>
            )
        }
    ]
}

export const INITIAL_DATA_QUERY = {
    page: 1,
    limit: 20,
    search: ''
}

export const TABLE_PAYROLL_DETAIL = {
    name: 'List Karyawan',
    column: [
        {
            name: "NIP",
            key: "nip",
            classNameHeader: "sticky z-10 left-[70px] !min-w-[100px]",
            className: "font-semibold max-w-0 sticky left-[70px] bg-white",
            sortable: true
        },
        {
            name: "Nama Karyawan",
            key: "full_name",
            classNameHeader: "sticky left-[170px] z-10 !min-w-[170px]",
            className: "font-semibold capitalize truncate max-w-0 sticky left-[170px] bg-white"
        },
        {
            name: "Job Title",
            key: "job_title",
            classNameHeader: "!min-w-[250px]",
            className: "font-semibold capitalize"
        },
        {
            name: "Department",
            key: "department",
            classNameHeader: "!min-w-[200px]",
            className: "font-semibold capitalize"
        },
        {
            name: "Divisi",
            key: "division",
            classNameHeader: "!min-w-[200px]",
            className: "capitalize"
        },
        {
            name: "Grade",
            key: "grade"
        },
        {
            name: "Join Date",
            key: "join_date",
            classNameHeader: "!min-w-[150px]",
            render: ({value}) => <div>{value ? formatDateMoment(value, 'D MMMM YYYY') : '-'}</div>
        },
        {
            name: "Nomor Rekening",
            key: "bank_account_number",
            classNameHeader: "!min-w-[150px]"
        },
        {
            name: "Hari Kerja",
            key: "working_days",
            classNameHeader: "!min-w-[110px]"
        },
        {
            name: "Hari Prorate",
            key: "prorate_days",
            classNameHeader: "!min-w-[110px]"
        },
        {
            name: "Total Earning",
            key: "total_earning",
            classNameHeader: "!min-w-[150px]",
            render: ({value}) => <div>{setCurrency(value)}</div>
        },
        {
            name: "Total Deduction",
            key: "total_deduction",
            classNameHeader: "!min-w-[150px]",
            render: ({value}) => <div>{setCurrency(value)}</div>
        },
        {
            name: "Take Home Pay",
            key: "take_home_pay",
            classNameHeader: "!min-w-[150px]",
            render: ({value}) => <div>{setCurrency(value)}</div>
        },
        {
            name: "Status Pengiriman Payroll",
            key: "payment_status",
            classNameHeader: "!min-w-[188px]",
            render: ({value}) => value ? <Badge title={value} type={value?.toLowerCase()}/> : ''
        },
    ]
}

export const INITIAL_DATA_QUERY_DETAIL = {
    page: 1,
    limit: 20,
    search: '',
    department_id: null,
    order_by: null,
    order_type: null
}
